export const CuePoints = [
  {
    "Name": "intro",
    "Start": "0:00.000",
    "Duration": "0:13.525"
  },
  {
    "Name": "help",
    "Start": "0:14.218",
    "Duration": "0:28.296"
  },
  {
    "Name": "help_deepdives",
    "Start": "0:21.357",
    "Duration": "0:03.642"
  },
  {
    "Name": "help_underline",
    "Start": "0:25.384",
    "Duration": "0:03.895"
  },
  {
    "Name": "help_audio",
    "Start": "0:30.686",
    "Duration": "0:03.323"
  },
  {
    "Name": "help_speaker",
    "Start": "0:34.132",
    "Duration": "0:01.867"
  },
  {
    "Name": "help_general",
    "Start": "0:36.548",
    "Duration": "0:02.053"
  },
  {
    "Name": "help_question_mark",
    "Start": "0:38.892",
    "Duration": "0:01.435"
  },
  {
    "Name": "help_scrolling",
    "Start": "0:40.574",
    "Duration": "0:01.939"
  },
  {
    "Name": "overlay_0",
    "Start": "0:43.633",
    "Duration": "0:08.097"
  },
  {
    "Name": "overlay_1",
    "Start": "0:52.805",
    "Duration": "0:06.107"
  },
  {
    "Name": "overlay_2",
    "Start": "0:59.422",
    "Duration": "0:16.175"
  },
  {
    "Name": "overlay_3",
    "Start": "1:16.868",
    "Duration": "0:10.400"
  },
  {
    "Name": "overlay_3_click",
    "Start": "1:25.434",
    "Duration": "0:00.000"
  },
  {
    "Name": "deepdive_0_0",
    "Start": "1:27.952",
    "Duration": "0:13.308"
  },
  {
    "Name": "deepdive_0_1",
    "Start": "1:42.102",
    "Duration": "0:03.610"
  },
  {
    "Name": "overlay_4",
    "Start": "1:46.384",
    "Duration": "0:08.768"
  },
  {
    "Name": "overlay_5",
    "Start": "1:56.222",
    "Duration": "0:13.022"
  },
  {
    "Name": "overlay_6",
    "Start": "2:10.851",
    "Duration": "0:14.551"
  },
  {
    "Name": "overlay_7",
    "Start": "2:26.755",
    "Duration": "0:13.244"
  },
  {
    "Name": "overlay_8",
    "Start": "2:41.181",
    "Duration": "0:05.767"
  },
  {
    "Name": "overlay_9",
    "Start": "2:48.419",
    "Duration": "0:10.905"
  },
  {
    "Name": "overlay_10",
    "Start": "3:00.092",
    "Duration": "0:05.504"
  },
  {
    "Name": "overlay_11",
    "Start": "3:06.514",
    "Duration": "0:05.760"
  },
  {
    "Name": "overlay_12",
    "Start": "3:13.192",
    "Duration": "0:07.725"
  },
  {
    "Name": "overlay_13",
    "Start": "3:22.010",
    "Duration": "0:15.438"
  },
  {
    "Name": "overlay_13_click",
    "Start": "3:38.039",
    "Duration": "0:05.029"
  },
  {
    "Name": "deepdive_1_0",
    "Start": "3:44.289",
    "Duration": "0:15.265"
  },
  {
    "Name": "deepdive_1_1",
    "Start": "4:01.519",
    "Duration": "0:33.297"
  },
  {
    "Name": "deepdive_1_2",
    "Start": "4:36.788",
    "Duration": "0:12.368"
  },
  {
    "Name": "deepdive_1_3",
    "Start": "4:50.318",
    "Duration": "0:09.214"
  },
  {
    "Name": "deepdive_1_4",
    "Start": "5:00.791",
    "Duration": "0:02.819"
  },
  {
    "Name": "overlay_14",
    "Start": "5:03.912",
    "Duration": "0:03.150"
  },
  {
    "Name": "overlay_15",
    "Start": "5:07.552",
    "Duration": "0:04.291"
  },
  {
    "Name": "overlay_16",
    "Start": "5:12.649",
    "Duration": "0:11.685"
  },
  {
    "Name": "overlay_17",
    "Start": "5:24.679",
    "Duration": "0:03.796"
  },
  {
    "Name": "overlay_18",
    "Start": "5:28.852",
    "Duration": "0:23.023"
  },
  {
    "Name": "deepdive_2_0",
    "Start": "5:53.163",
    "Duration": "0:09.320"
  },
  {
    "Name": "deepdive_2_1",
    "Start": "6:02.863",
    "Duration": "0:10.421"
  },
  {
    "Name": "deepdive_2_2",
    "Start": "6:13.765",
    "Duration": "0:06.271"
  },
  {
    "Name": "overlay_19",
    "Start": "6:20.338",
    "Duration": "0:04.939"
  },
  {
    "Name": "overlay_20",
    "Start": "6:25.549",
    "Duration": "0:05.851"
  },
  {
    "Name": "overlay_21",
    "Start": "6:31.817",
    "Duration": "0:14.178"
  },
  {
    "Name": "overlay_22",
    "Start": "6:47.834",
    "Duration": "0:11.141"
  },
  {
    "Name": "overlay_23",
    "Start": "6:59.722",
    "Duration": "0:18.417"
  },
  {
    "Name": "deepdive_3_0",
    "Start": "7:19.544",
    "Duration": "0:03.538"
  },
  {
    "Name": "outro",
    "Start": "7:28.856",
    "Duration": "0:25.080"
  }
]